import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SetState, addSiteInfo } from "../../../redux/reducers/admin";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import "../personalInfo.css";

const AddInfo = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {} = useSelector((state) => state.admin);
  const [infoObj, setInfoObj] = useState({});
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setInfoObj({
      ...infoObj,
      [name]: value,
    });
  };

  const createPersonalInfo = () => {
    const { contact1, contact2, email1, email2, address } = infoObj;
    if (!contact1 || !email1 || !address) {
      toast.error("Kindly fill required fields");
      return;
    }
    const data = {
      contact1,
      contact2,
      email1,
      email2,
      address,
    };
    dispatch(addSiteInfo(data)).then(() => history.push("/admin/personalInfo"));
  };

  return (
    <div className="animated fadeIn">
      <ToastContainer autoClose={20000} />
      <Row>
        <Col xs="12" lg="12">
          <Card>
            <CardHeader>
              <Row>
                <Col xs="12" sm="10">
                  <i className="fa fa-align-justify m-2"></i>
                  <strong> Add Site Info </strong>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <FormGroup>
                <Row>
                  <Col xs="12" sm="5" md="5" lg="5">
                    <Label>
                      <b>
                        Contact Number Primary{" "}
                        <span className="required">*</span>{" "}
                      </b>
                    </Label>
                  </Col>
                  <Col xs="12" sm="4" md="5" lg="4">
                    <Input
                      type="text"
                      name="contact1"
                      onChange={handleInputChange}
                      placeholder="primary contact number"
                      className="capitalize-placeholder"
                    />
                    {/* <p className="onerror"> {state.formErrors.contact1}</p> */}
                  </Col>
                </Row>
              </FormGroup>

              <FormGroup>
                <Row>
                  <Col xs="12" sm="5" md="5" lg="5">
                    <Label>
                      <b>Contact Number Secondary</b>
                    </Label>
                  </Col>
                  <Col xs="12" sm="4" md="5" lg="4">
                    <Input
                      type="text"
                      name="contact2"
                      onChange={handleInputChange}
                      placeholder="secondary contact number"
                      className="capitalize-placeholder"
                    />
                  </Col>
                </Row>
              </FormGroup>

              <FormGroup>
                <Row>
                  <Col xs="12" sm="5" md="5" lg="5">
                    <Label>
                      <b>
                        Email Primary <span className="required">*</span>{" "}
                      </b>
                    </Label>
                  </Col>
                  <Col xs="12" sm="4" md="5" lg="4">
                    <Input
                      type="email"
                      name="email1"
                      onChange={handleInputChange}
                      placeholder="email"
                      className="capitalize-placeholder"
                    />
                    {/* <p className="onerror"> {state.formErrors.email1}</p> */}
                  </Col>
                </Row>
              </FormGroup>

              <FormGroup>
                <Row>
                  <Col xs="12" sm="5" md="5" lg="5">
                    <Label>
                      <b>Email Secondary</b>
                    </Label>
                  </Col>
                  <Col xs="12" sm="4" md="5" lg="4">
                    <Input
                      type="email"
                      name="email2"
                      onChange={handleInputChange}
                      placeholder="email"
                      className="capitalize-placeholder"
                    />
                  </Col>
                </Row>
              </FormGroup>

              <FormGroup>
                <Row>
                  <Col xs="12" sm="5" md="5" lg="5">
                    <Label>
                      <b>
                        Address <span className="required">*</span>{" "}
                      </b>
                    </Label>
                  </Col>
                  <Col xs="12" sm="4" md="5" lg="4">
                    <Input
                      type="text"
                      name="address"
                      onChange={handleInputChange}
                      placeholder="address"
                      className="capitalize-placeholder"
                    />
                  </Col>
                </Row>
              </FormGroup>

              <Row>
                <Col xs="12" sm="5" md="5" lg="5"></Col>
                <Col xs="12" sm="4" md="5" lg="4">
                  <Button
                    color="primary"
                    type="submit"
                    className="btn btn-sm"
                    onClick={() => createPersonalInfo()}
                    block
                  >
                    Save
                  </Button>
                </Col>
                <Col xs="12" sm="4" md="4" lg="3"></Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AddInfo;
